// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as PolylineSplitter from "../helper/PolylineSplitter.bs.js";

function getPolylineViews(trip_started_time, polylinesInfo) {
  if (trip_started_time !== undefined) {
    if (polylinesInfo === undefined) {
      return {
              billed: undefined,
              dry_run: undefined,
              complete: undefined
            };
    }
    var trip_started_idx = PolylineSplitter.splitRoute(Caml_option.valFromOption(trip_started_time), polylinesInfo.line) + 1 | 0;
    return {
            billed: $$Array.map((function (a) {
                    return a.point;
                  }), $$Array.sub(polylinesInfo.line, trip_started_idx, polylinesInfo.line.length - trip_started_idx | 0)),
            dry_run: $$Array.map((function (a) {
                    return a.point;
                  }), $$Array.sub(polylinesInfo.line, 0, trip_started_idx)),
            complete: $$Array.map((function (a) {
                    return a.point;
                  }), polylinesInfo.line)
          };
  }
  if (polylinesInfo === undefined) {
    return {
            billed: undefined,
            dry_run: undefined,
            complete: undefined
          };
  }
  var polylineArray = $$Array.map((function (a) {
          return a.point;
        }), polylinesInfo.line);
  return {
          billed: undefined,
          dry_run: polylineArray,
          complete: polylineArray
        };
}

export {
  getPolylineViews ,
  
}
/* PolylineSplitter Not a pure module */
